import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useSubmitData } from "../../../hooks/useSubmitData";
import { useSetMenu } from "../../../hooks/useSetMenu";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import * as yup from "yup";
import FormSelect from '../../Generic/FormSelect';

const Add = () => {

    const { mainStore } = useStore();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    useSetMenu(mainStore.CategoryMenuType, mainStore.CategoryMenuNo);
    const onError = (errors, e) =>
        enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });

    const schema = yup.object({
        name: yup
            .string()
            .required(t('requiredField'))
            .max(250, t('maxLength', { max: 250 })),
        panelId: yup.string().required(t("selectRequired")),
    });

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const sendData = useSubmitData(axiosPrivate, "/Categories", "/Category/List");
    const onSubmit = data => sendData(data);
    const onCancel = () => navigate(-1);

    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, [t]);

    //#region Panel Select
    const [panels, setPanels] = useState([]);
    async function loadData() {
        try {
            const panelsResponse = await axiosPrivate.get("/Panels/SelectOptions");
            setPanels(panelsResponse.data);
        } catch (err) {
            enqueueSnackbar(t("loadDataError"), { variant: "error" });
        }
    }
    const handlePanelChange = selectedOption => {
        setValue("panelId", selectedOption.value, { shouldValidate: true });
    };
    //#endregion

    return (
        <FormLayout title={t("categoryCreateTitle")} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
            <FormSelect label="panel" name="panelId" register={register} errors={errors} options={panels} onChange={handlePanelChange} />
            <FormInput label="category" name="name" register={register} errors={errors}/>
        </FormLayout>
    );
};

export default Add;